<template>
    <div class="the-detail-inner" v-bind:class="{'detail-visible': showDetailPage}">
        <section>
            <div class="info">
                <table class="table table--overview">
                    <tbody>
                        <tr>
                            <td>
                                {{$t('user.support.ticket.detail.created')}}
                            </td>
                            <td>
                                {{createdDate}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {{$t('user.support.ticket.detail.tag')}}
                            </td>
                            <td>
                                {{areaName}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {{$t('user.support.ticket.detail.state')}}
                            </td>
                            <td>
                                {{supportTicketDetail.data.state}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
        <hr/>
        <section>
            <h2>{{$t('user.support.ticket.detail.conversationtitle')}}</h2>
            <div class="conversation">
                <div
                        v-for="(article, index) in articles"
                        v-bind:key="index"
                >

                    <div class="item" v-bind:class="article.sender">
                      <span v-if="article.sender === 'Agent'" class="item__sender">BackupMonkey Support</span>
                      <span v-else class="item__sender">You</span>
                      <hr/>
                      <div v-html="article.body" v-if="article.sender === 'Agent'">
                      </div>

                      <div v-html="nl2br(article.body)" v-else>
                      </div>
                    </div>

                </div>
            </div>
        </section>
        <hr/>
        <section>
            <h2>{{$t('user.support.ticket.detail.formtitle')}}</h2>

            <div class="form-group">
                <label for="text">{{$t('user.support.ticket.detail.reply')}}</label>
                <textarea
                        id="text"
                        class="form-control"
                        v-model="replytext"
                        placeholder="Enter your message"
                        rows="5"
                        required="required"
                ></textarea>
            </div>

            <div class="actions">
                <button class="btn btn--success" v-on:click="submitForm()">{{$t('user.support.submitreply')}}</button>
            </div>

        </section>
    </div>

</template>

<script>

import { mapActions, mapMutations, mapState } from 'vuex'

import mixins from '../../mixins'

export default {

  name: 'SupportTicketDetailDefault',

  mixins: [mixins],

  components: {
  },

  computed: {
    ...mapState('user', [
      'userTimezone'
    ]),

    ...mapState('support', [
      'tags',
      'supportTicketDetail',
      'showDetailPage'
    ]),

    createdDate () {
      return this.transformTime(this.supportTicketDetail.data.created, this.userTimezone)
    },

    areaName () {
      const tag = this.tags.filter((element) => {
        return element.id === this.supportTicketDetail.data.tag_id
      })

      return tag.length > 0 ? tag[0].name : ''
    },

    articles () {
      if (!this.supportTicketDetail.data.articles) {
        return []
      }
      return this.supportTicketDetail.data.articles.filter((element) => {
        return element.type !== 1
      })
    }

  },

  data () {
    return {
      replytext: ''
    }
  },

  methods: {

    ...mapMutations('support', [
      'closeSiteDetailPage',
      'setSupportTicketDetail'
    ]),

    ...mapActions('support', [
      'reply',
      'getTickets'
    ]),

    async submitForm () {
      if (this.replytext === '') {
        return
      }

      const payload = {
        ticket_id: this.supportTicketDetail.data.id,
        reply: this.replytext
      }

      await this.reply(payload)

      // refresh data
      await this.getTickets()
      await this.setSupportTicketDetail(this.supportTicketDetail.data.id)

      this.replytext = ''
    },

    nl2br (str) {
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br />' + '$2')
    },

    close () {
      this.closeSiteDetailPage()
    }

  }
}
</script>
